/*
 * @Author: lvjun
 * Date：2021-27 14:30:43
 * @Description: 
 */
/*
* @desc 将第三方插件注册到Vue原型中，组件内可直接使用 this.xxx来调用组件
* @update --
*/
import * as filters from '@public/utils/filters.js'
import { bus, hasPower, taday, interfaceWaitHandle } from '../utils/common'
export default {
  customPlugin: {
    install (Vue, options) {
      // 将第三方插件注册到Vue原型中，组件内可直接使用 this.xxx来调用组件
      Object.assign(Vue.prototype, {
        $bus: bus,
        $lang: filters.lang,
        $taday: taday,
        $hasPower: hasPower,
        $interfaceWaitHandle: interfaceWaitHandle
      })
    }
  }
}
